import {
    isPokerAudioPresetId,
    POKER_AUDIO_PRESETS
} from './PokerAudioPresetConfig';
import type {
    PokerAudioPreset,
    PokerAudioPresetId
} from './PokerAudioPresetConfig';

export type {
    CommunityCardPlacementSound,
    PokerAudioPreset,
    PokerAudioPresetId,
    PokerSoundKey
} from './PokerAudioPresetConfig';

const STORAGE_KEY = 'pokersolutions.poker.audioPreset';
const DEFAULT_PRESET_ID = POKER_AUDIO_PRESETS[0].id;

export class PokerAudioPresetManager {
    private selectedPresetId: PokerAudioPresetId;

    constructor() {
        this.selectedPresetId = this.readStoredPresetId();
    }

    public getPresets = (): readonly PokerAudioPreset[] => {
        return POKER_AUDIO_PRESETS;
    };

    public getSelectedPresetId = (): PokerAudioPresetId => {
        return this.selectedPresetId;
    };

    public getSelectedPreset = (): PokerAudioPreset => {
        return this.getPreset(this.selectedPresetId);
    };

    public getPreset = (presetId: PokerAudioPresetId): PokerAudioPreset => {
        return POKER_AUDIO_PRESETS.find((preset) => preset.id === presetId) || POKER_AUDIO_PRESETS[0];
    };

    public setSelectedPresetId = (presetId: PokerAudioPresetId): PokerAudioPresetId => {
        this.selectedPresetId = presetId;
        this.storePresetId(presetId);
        return this.selectedPresetId;
    };

    public getPlayerActionSoundFile = (
        action: string | undefined,
        roomType: string | undefined
    ): string | null => {
        const sounds = this.getSelectedPreset().sounds;

        switch (action) {
            case 'fold':
                return sounds.fold;
            case 'check':
                return sounds.check;
            case 'ante':
            case 'bet':
                return sounds.bet;
            case 'call':
                return sounds.call;
            case 'raise':
                return sounds.raise;
            case 'all-in':
                return roomType === 'aof' ? sounds.raise : sounds.allIn;
            default:
                return null;
        }
    };

    private readStoredPresetId = (): PokerAudioPresetId => {
        if (typeof window === 'undefined') return DEFAULT_PRESET_ID;
        try {
            const storedPresetId = window.localStorage.getItem(STORAGE_KEY);
            return isPokerAudioPresetId(storedPresetId) ? storedPresetId : DEFAULT_PRESET_ID;
        } catch (_) {
            return DEFAULT_PRESET_ID;
        }
    };

    private storePresetId = (presetId: PokerAudioPresetId) => {
        if (typeof window === 'undefined') return;
        try {
            window.localStorage.setItem(STORAGE_KEY, presetId);
        } catch (_) {}
    };
}
